<!-- 商城商品展示页面 -->
<template>
  <div class="goods-page-wrapper">
    <!-- 固定头部区域 -->
    <div class="goods-fixed-header">
      <SearchHeader
        v-model="value"
        readonly
        @back="goBack"
        @focus="onSearch"
      />
      <div v-if="boo2">
        <tab v-if="category.length > 1" :title="category" ref="firstTab" @scrollToAll="scrollToAll" @clossSecondPop="clossSecondPop"></tab>
        <SecondTab v-if="tempList.length > 0" class="second-tab-wrapper" :title="tempList" ref="secondTab"
          @scrollTo="scrollTo">
        </SecondTab>
        <SortFilter 
          :priceType="form.priceType" 
          @sort-default="setNomal" 
          @sort-price="setPrictType" 
        />
      </div>
    </div>
    <!-- 商品列表区域（可滚动） -->
    <div v-if="boo2" class="goods-scroll-area" ref="scrollArea" @scroll="handleScroll">
      <loading v-if="loading"></loading>
      <div v-else>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div v-if="list.length > 0">
            <van-list v-model="loading2" :finished="finished" finished-text="没有更多了" @load="nextPage">
              <goods-list-com :DataList="list"> </goods-list-com>
            </van-list>
          </div>
          <div class="empt" v-else>
          </div>
        </van-pull-refresh>
      </div>
    </div>
    <seachview v-else ref="seach" :value="value" @value="seachvalue" :type="0"></seachview>
    <!-- 引入定位组件并监听定位完成事件 -->
    <LocationComponent @location-finish="onLocationFinish" />
    <!-- 返回顶部按钮 -->
    <div v-if="showBackTop" class="back-top-btn" @click="scrollToTop">
      <van-icon name="arrow-up" size="1.2rem" />
      <span>顶部</span>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import HeadChild from "../../components/HeadChild";
import NaigateTool from '../../components/index/NavigateTool';
import Tab from "../../components/goodlist/Tab.vue";
import SecondTab from "../../components/goodlist/SecondTab.vue";
import SearchHeader from "../../components/goodlist/SearchHeader.vue";
import SortFilter from "../../components/goodlist/SortFilter.vue";
import Seachview from "../../components/index/Seachview.vue";
// 商品详情列表
import GoodsListCom from "../../components/GoodsListCom.vue";
import LocationComponent from '@/components/map/Location.vue';
import { mapState } from 'vuex';
import {
  cacheGoodsListCategory,
  readGoodsListCategoryCache,
} from '@/utils/categoryNav';
let initViewfinish = false

export default {
  name: "GoodsList",
  props: {},
  data() {
    return {
      col: 2,
      page: 1,
      boo2: true,

      // //列宽-有指定列数则此属性失效
      // colWidth: (pc ? window.innerHeight : window.innerWidth) / 2,
      // // 列数和列宽模式切换
      // mode: 0,
      list: [],
      currentPage: 0, // 当前页码
      pageSize: 10, // 每页个数
      totalSize: 10, // 总个数
      loading2: false, // 加载下一页
      finished: false, // 是否加载完了
      refreshing: false,
      checkList: [], // 列表数据
      tabindexL: 1,
      loading: false,
      category: [],
      tempList: [],
      /** 从路由带入的二级 Tab 下标，scrollToAll 时消费 */
      _pendingSecondIndex: null,
      value: null,
      // 刷新
      isLoading: false,
      form: {
        cardId: '',
        current: 1, // 当前页码
        size: 10, // 每页个数
        category1Id: '',
        category2Id: '',
        cityCode: '',
        upgradeFlag: '',
        bathId: '',
        priceType: null,//null 默认推荐  1 升序  0 降序  
      },
      cakaList: [],
      cakeForm: {
        brandId: '',
        cardId: '',
        cityCode: '',
        current: 1,
        size: 20,
        productType: 0,
      },
      titles: [],
      active: 0,
      active2: 0,
      searchValue: '',
      entorcode: '',
      indexName: null,
      isFirstHttp: true,
      upgradeFlag: '',
      bathId: '',
      fromType: null,
      // 标记是否已加载数据
      dataLoaded: false,
      showBackTop: false,
    };
  },
  components: {
    HeadChild,
    Tab,
    SecondTab,
    SearchHeader,
    SortFilter,
    NaigateTool,
    Seachview,
    GoodsListCom,
    LocationComponent,
  },
  methods: {

    setPrictType() {
      if (this.form.priceType) {
        if (this.form.priceType == '1') {
          this.form.priceType = '0'
        } else {
          this.form.priceType = '1'
        }
      } else {
        this.form.priceType = '1'
      }
      this.onRefresh()
    },
    setNomal() {
      this.form.priceType = null
      this.onRefresh()
    },
    // 滚动监听
    handleScroll(e) {
      const scrollTop = e.target.scrollTop;
      this.showBackTop = scrollTop > 300;
    },
    // 返回顶部
    scrollToTop() {
      if (this.$refs.scrollArea) {
        this.$refs.scrollArea.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },

    // 返回
    goBack() {
      if (this.boo2) {
        this.$router.back();
      } else
        this.boo2 = true;
    },
    onSearch() {
      // this.$refs.seach.seach(this.value);
      // this.boo2 = false;
      this.$router.push({
        path: "/SearchGoods",
        query: {
          showType: 'noLocation'
        }
      });
    },
    //子组件分发的事件  点击历史记录重新给输入框赋值
    seachvalue(val) {
      this.value = val;
    },
    clossSecondPop() {
      if (this.$refs.secondTab) {
        this.$refs.secondTab.clossPop()
      }
      if (this.$refs.thirdTab) {
        this.$refs.thirdTab.clossPop()
      }
    },
    nextPage() { // 加载下一页
      if (this.list.length >= 10) {
        this.loading = false
        this.form.current += 1
        this.getData()
      }
    },
    getTabIndex(index) {
      this.tabindexL = index
      Toast("刷新成功" + index);
    },
    // 刷新
    onRefresh() {
      setTimeout(() => {
        this.form.current = 1
        this.finished = false
        this.list = []
        this.getData();
        this.isLoading = false;
      }, 500);
    },
    getData() {
      this.form.bathId = this.bathId
      this.form.upgradeFlag = this.upgradeFlag
      this.$api
        .queryProductInfoHomeNew(this.form)
        .then((res) => {

          if (res.code == 1) {
            Toast(res.msg)
            return
          }
          if (this.form.current == 1) {
            this.list = res.data.records
          } else {
            this.list.push(...res.data.records)
          }

          this.loading = false;
          this.loading2 = false;

          if (this.form.current >= res.data.pages) {
            this.finished = true
          }
        })
        .catch((err) => {
          this.loading = false;
          this.loading2 = false;
        });
    },
    // 使用 MALL_GOODS 分类数据初始化（后端已裁剪，直接使用）
    initWithCategoryData(categoryData) {
      this.category = (categoryData || []).map((item) => ({
        id: item.id,
        name: item.name,
        icon: item.icon,
        categoryScene: item.categoryScene,
        navRoute: item.navRoute,
        jumpPageFlag: item.jumpPageFlag,
        children: item.children || [],
      }));

      const qIndex1 = parseInt(this.$route.query.index1);
      if (!isNaN(qIndex1) && qIndex1 >= 0 && qIndex1 < this.category.length) {
        this.active = qIndex1;
      } else if (this.indexName) {
        this.category.forEach((element, index) => {
          if (element.name === this.indexName) {
            this.active = index;
          }
        });
      }

      const qIndex2 = parseInt(this.$route.query.index2);
      if (!isNaN(qIndex2) && qIndex2 >= 0) {
        this._pendingSecondIndex = qIndex2;
      }

      this.$nextTick(() => {
        if (this.category.length > 1 && this.$refs.firstTab) {
          this.$refs.firstTab.clickCard(this.active, true);
        } else if (this.category.length === 1) {
          this.scrollToAll(0);
        }
      });
    },
    // 分类一级名字(降级查询:无缓存时调用新接口一次获取一二级分类)
    getTitle1() {
      this.$api
        .selectCategoryWithChildren(this.bathId, this.upgradeFlag, this.form.cityCode, 'MALL_GOODS')
        .then((res) => {
          if (res.code === 0 && res.data) {
            // 存储到sessionStorage供后续使用
            cacheGoodsListCategory(res.data);
            this.initWithCategoryData(res.data);
          } else {
            if (res.code == 1) {
              this.$Toast(res.msg);
              return
            }
          }
        })
        .catch((err) => {
        });
    },
    // 分类页面数据(优先使用本地children)
    onClick(val, index) {
      this.form.category1Id = val
      // 从本地category中查找children
      const currentCategory = this.category.find(c => c.id === val);
      if (currentCategory && currentCategory.children && currentCategory.children.length > 0) {
        // 使用本地缓存的二级分类数据
        this.tempList = [{ id: '', name: '全部' }, ...currentCategory.children];
        this.form.category2Id = this.tempList[index].id;
        this.$nextTick(() => {
          this.$refs.secondTab.clickCard(this.active2);
        });
      }
    },
    scrollToAll(index) {
      this.active = index
      this.finished = false
      let secondIndex = 0
      if (this._pendingSecondIndex != null) {
        secondIndex = this._pendingSecondIndex
        this._pendingSecondIndex = null
        this.active2 = secondIndex
      } else if (!this.isFirstHttp) {
        this.active2 = 0
      } else {
        this.isFirstHttp = false
      }
      this.list = []
      this.scrollToTop()
      this.onClick(this.category[index].id, secondIndex);
    },
    scrollTo(index) {
      this.active2 = index
      this.form.current = 1
      this.finished = false
      this.loading2 = true
      this.list = []
      this.scrollToTop()
      this.form.category2Id = this.tempList[index].id
      this.getData();
    },
    // 位置选择
    Switch() {
      this.$router.push("SelectAdderss");
    },
    // 调用子组件的方法
    seach() {
      this.$refs.seach.seach(this.value);
    },
    //子组件分发的事件  点击历史记录重新给输入框赋值
    seachvalue(val) {
      this.value = val;
    },
    repaints() {
      this.$refs.waterfall.repaints(0, 0.4);
    },
    initView() {
      // 如果已经加载过数据，不再重复加载
      if (this.dataLoaded) {
        return;
      }
      // 标记数据已加载
      this.dataLoaded = true;
      
      this.active = parseInt(this.$route.query.index1) ? parseInt(this.$route.query.index1) : 0
      this.active2 = parseInt(this.$route.query.index2) ? parseInt(this.$route.query.index2) : 0
      this.indexName = this.$route.query.indexName
      this.entorcode = localStorage.getItem('entrCode')
      this.isFirstHttp = true
      this.fromType = this.$route.query.from
      this.upgradeFlag = localStorage.getItem("upgradeFlag");
      this.bathId = localStorage.getItem("bathId");
      this.form.cardId = localStorage.getItem("cardId");
      if(!this.form.cityCode) {
        return;
      }
      this.list = []
      
      // 优先从sessionStorage读取分类数据
      const cachedCategoryData = readGoodsListCategoryCache();
      if (cachedCategoryData) {
        this.initWithCategoryData(cachedCategoryData);
      } else {
        // 无缓存则调用新接口查询
        this.getTitle1();
      }
    },
    
    /**
     * 定位完成后的回调
     * @param {Object} locationInfo 定位信息
     */
    onLocationFinish(locationInfo) {
      console.log('定位完成，城市信息:', locationInfo);
      this.form.cityCode = locationInfo.cityCode;
      // 标记数据未加载
      this.dataLoaded = false;
      this.initView();
    }
  },
  mounted() {
    // this.getData();
    // this.active = parseInt(this.$route.query.index1) ? parseInt(this.$route.query.index1) : 0
    // this.active2 = parseInt(this.$route.query.index2) ? parseInt(this.$route.query.index2) : 0
    // this.indexName = this.$route.query.indexName
    // this.entorcode = localStorage.getItem('entrCode')
    // this.fromType = this.$route.query.from
    // this.upgradeFlag = localStorage.getItem("upgradeFlag");
    // this.bathId = localStorage.getItem("bathId");

    // this.getTitle1(this.active2)
    // // // 是否有手动选择地址
    // this.address = localStorage.getItem("address");
    // this.form.cardId = localStorage.getItem('cardId')
    // this.form.cityCode = localStorage.getItem("cityCode");
  },
  computed: {
    // 获取定位地址信息
    ...mapState({
      address: state => state.address,
      cityCode: state => state.cityCode
    })
  },
  inject: ["reload"],
  beforeRouteEnter(to, from, next) {
    to.meta.keepAlive = true
    const isDetail = /^\/Details/i.test(from.path);
    if (!isDetail) {
      next((vm) => {
        vm.$nextTick(() => {
          vm.initView()
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0
        })
      });
    } else {
      initViewfinish = true
      next();
    }
  },
  created() {
    if (initViewfinish) {
      initViewfinish = false
      this.initView()
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0
    }
  },
  watch: {
    '$route': function (to, from) {
      // 只有来源不是详情页时，才允许重置数据加载状态
      const isFromDetail = /^\/Details(\/.*)?$/i.test(from.path);
      if (!isFromDetail) {
        this.dataLoaded = false;
      }
      
      if (this.active > 0) {
        this.$refs.firstTab.indexTo(this.active, false)
      }
      if (this.active2 > 0) {
        this.$refs.secondTab.indexTo(this.active2)
      }
    },
    // 监听城市代码变化
    cityCode(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        // 标记数据未加载
        this.dataLoaded = false;
        // 更新表单中的城市代码
        this.form.cityCode = newVal;
      }
    }
  },
  activated() {
    const scrollTop = this.$route.meta.scrollTop;
    if (scrollTop && this.$refs.scrollArea) {
      this.$nextTick(() => {
        this.$refs.scrollArea.scrollTop = scrollTop;
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    const isDetail = /^\/Details/i.test(to.path);
    if (isDetail && this.$refs.scrollArea) {
      from.meta.scrollTop = this.$refs.scrollArea.scrollTop;
    } else {
      from.meta.scrollTop = 0;
    }
    next();
  },
};
</script>

<style lang='scss' scoped>
@import '@/styles/goodslist.scss';

.empt {
  display: flex;
  flex-direction: column;
  height: 60vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  color: #999;
}
</style>